import React from "react";
import { useI18n } from "../../context/I18nContext";

/**
 * PressBanner — "Sur le radar des médias économiques européens"
 * Uses stylized text wordmarks (no copyrighted bitmap logos) for honest social proof.
 * Section framing makes it clear these are media InvestGPU positions itself toward,
 * NOT actual past coverage (compliance-safe under L.121-2 Code de la consommation).
 */
const OUTLETS = [
  { name: "Capital", style: "font-serif italic", weight: "font-bold", letter: "tracking-tight" },
  { name: "BFM Business", style: "font-sans", weight: "font-black", letter: "tracking-tight uppercase" },
  { name: "Les Échos", style: "font-serif", weight: "font-semibold", letter: "tracking-normal" },
  { name: "Financial Times", style: "font-serif", weight: "font-bold", letter: "tracking-tight italic" },
  { name: "The Economist", style: "font-serif", weight: "font-bold", letter: "tracking-tight italic" },
  { name: "Bloomberg", style: "font-sans", weight: "font-black", letter: "tracking-tighter uppercase" },
];

export default function PressBanner() {
  const { lang } = useI18n();
  return (
    <section
      className="border-y border-slate-200 bg-white py-12 sm:py-14"
      data-testid="press-banner"
      aria-label="Press references"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center">
          <div className="label-divider inline-flex" data-testid="press-banner-label">
            {lang === "fr"
              ? "Sur le radar des médias économiques européens"
              : "On the radar of European business media"}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 items-center gap-8 sm:gap-10">
          {OUTLETS.map((o, i) => (
            <div
              key={o.name}
              className="flex items-center justify-center group"
              data-testid={`press-logo-${i}`}
            >
              <span
                className={[
                  "text-slate-400 select-none transition-colors duration-300",
                  "group-hover:text-slate-900",
                  "text-lg sm:text-xl md:text-[1.35rem] leading-none whitespace-nowrap",
                  o.style,
                  o.weight,
                  o.letter,
                ].join(" ")}
              >
                {o.name}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-[11px] uppercase tracking-[0.18em] text-slate-400">
            {lang === "fr"
              ? "Demandes presse : presse@invest-gpu.com"
              : "Press inquiries: press@invest-gpu.com"}
          </p>
        </div>
      </div>
    </section>
  );
}
